import React from 'react';
import styled from 'styled-components';
import { css } from '/imports/ui/css';
import { maxLongFieldLength } from '/imports/inputLimits';

const TextAreaStyled = styled.textarea`
  border: ${css.inputBorder};
  border-radius: ${css.inputBorderRadius};
  padding: 0.5rem 0.75rem;
  box-sizing: border-box;
  font-size: 1rem;
  font-family: ${css.fontFamily};
  &:disabled {
    background: ${css.grey6};
  }
`;

export interface TextAreaProps {
  id?: string;
  className?: string;
  placeholder?: string;
  value?: string;
  defaultValue?: string;
  disabled?: boolean;
  onChange?(text: string): void;
  onFocus?(e: React.FocusEvent<HTMLTextAreaElement, Element>): void;
  onBlur?(e: React.FocusEvent<HTMLTextAreaElement, Element>): void;
  onKeyDown?(e: React.KeyboardEvent<HTMLTextAreaElement>): void;
  maxLength?: number;        // defaults to the long-field ceiling, so the browser stops a paste the server would refuse
}

/**
 * Styled textarea wrapper that forwards value and event handlers.
 */
export const TextArea = (props: TextAreaProps) => {
  return (
    <TextAreaStyled
      id={props.id}
      className={props.className}
      placeholder={props.placeholder || ''}
      value={props.value}
      defaultValue={props.defaultValue}
      disabled={props.disabled}
      maxLength={props.maxLength ?? maxLongFieldLength}
      onChange={(e) => props.onChange?.(e.target.value)}
      onFocus={props.onFocus}
      onBlur={props.onBlur}
      onKeyDown={props.onKeyDown}
    />
  );
};